/*
 * This contains all the edge option
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  'same-color': {
    id: 'cwt.translations.same-color',
    defaultMessage: 'Same color',
    description: {
      labelGroup: 'Edge expressions',
    },
  },
  aluminium: {
    id: 'cwt.translations.aluminium',
    defaultMessage: 'Solid aluminium',
    description: {
      labelGroup: 'Edge expressions',
    },
  },
  straight: {
    id: 'cwt.translations.straight',
    defaultMessage: 'Straight',
    description: {
      labelGroup: 'Edge shapes',
    },
  },
  chamfered: {
    id: 'cwt.translations.chamfered',
    defaultMessage: 'Chamfered',
    description: {
      labelGroup: 'Edge shapes',
    },
  },
  round: {
    id: 'cwt.translations.round',
    defaultMessage: 'Round',
    description: {
      labelGroup: 'Edge shapes',
    },
  },
  'half-round': {
    id: 'cwt.translations.half-round',
    defaultMessage: 'Half round',
    description: {
      labelGroup: 'Edge shapes',
    },
  },
  bevel: {
    id: 'cwt.translations.bevel',
    defaultMessage: 'Bevel',
    description: {
      labelGroup: 'Edge shapes',
    },
  },
  'anti-drip': {
    id: 'cwt.translations.anti-drip',
    defaultMessage: 'Anti-drip',
    description: {
      labelGroup: 'Edge shapes',
    },
  },
});
